import React from 'react';
import { TITLES, ROUTES } from '../../../constants';
import { TitleBar } from '../../common';
import MixBoxInputTable from './MixBoxInputTable';

export const MixBox = () => {
  return (
    <>
      <TitleBar
        title={[
          { text: TITLES.PACKAGE, route: ROUTES.PACKAGE },
          { text: TITLES.ADD_BOX, route: ROUTES.NULL },
        ]}
      />
      <div className="scroll-div h-100">
        <MixBoxInputTable />
      </div>
    </>
  );
};
